export default "images/sleep.png";